import React from "react";

const Body = ({ children }) => {
  return (
    <div className="absolute top-[10%] left-[10%] w-[80%]">{children}</div>
  );
};
export default Body;
